<template>
  <div>
    <EmptyModal
      v-if="modalOrderDrugData"
      ref="emptyOrderModal"
      :onModalClose="closeModal"
      :modalData="modalOrderDrugData"
      :onModalAccept="() => $refs.orderDrugMain.createOrder()"
    >
      <!--      :onModalAccept="() => $refs.orderDrugMain.$refs.drugOrder.createOrder()"-->
      <slot>
        <OrderDrugMain
          ref="orderDrugMain"
          :countrySelected="countrySelected"
          :drugId="modalOrderDrugData.drug.id"
          :profitCalculation="profitCalculation"
          :updateOrderedInvoices="updateOrderedInvoices"
          :closeModal="closeModal"
        />
      </slot>
    </EmptyModal>

    <EmptyModal
      v-if="modalData"
      ref="emptyModal"
      :onModalClose="closeModal"
      :modalData="modalData"
      :onModalAccept="saveNewPrices"
    >
      <slot>
        <div>
          <template v-if="modalData.type === 'countryEdit'">
          </template>
          <template v-else>
            <table class="table table-sm mt-0 priceData">
              <tbody>
              <template v-for="(project, pi) in getSortedProjects()" v-if="!hidePrices[project.id]">
                <tr v-for="(price, index) in getPrices(modalData.prices, project.id)">
                  <td class="project_block" v-if="index === 0"
                      :rowspan="getPrices(modalData.prices, project.id).length">
                    {{ project.title }}
                  </td>
                  <td>
                    <template v-if="pi === 0 && price.qty !== 1">
                      <input v-model="price.freeze" type="checkbox">
                    </template>
                  </td>
                  <td>
                    <div class="input-group mb-1">
                      <div class="input-group-prepend">
                        <template v-if="index === 0">
                          <div class="input-group-text"><strong>{{ price.qty }}</strong></div>
                        </template>
                        <template v-else>
                          <select @change="updateDataToSave(modalData, 'prices', price.site_id, price)"
                                  v-model="price.qty"
                                  :disabled="price.to_remove" class="custom-select">
                            <option v-for="qty in 9" :value="(qty + 1)">{{ qty + 1 }}</option>
                          </select>
                        </template>
                      </div>
                      <input type="text" @change="updateDataToSave(modalData, 'prices', price.site_id)"
                             v-model="price.price" :disabled="price.to_remove" class="form-control">
                      <div class="input-group-append">
                        <div class="input-group-text"><strong>{{ getProfitPercent(modalData, price.price) }}%</strong>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <template v-if="useRates[price.site_id] && showPriceRates">
                      <input type="number" :disabled="+price.qty !== 1"
                             @change="updateDataToSave(modalData, 'prices', price.site_id)"
                             class="form-control" placeholder="фасовка" v-model="price.packing">
                    </template>
                  </td>
                  <td>
                    <template v-if="useRates[price.site_id] && showPriceRates">
                      <input type="number" :disabled="+price.qty !== 1"
                             @change="updateDataToSave(modalData, 'prices', price.site_id)"
                             class="form-control" placeholder="коэффициент" v-model="price.rate">
                    </template>
                  </td>
                  <td>
                    <input type="number"
                           @change="updateDataToSave(modalData, 'prices', price.site_id)"
                           disabled class="form-control" placeholder="цена на сайте" v-model="price.project_price">
                  </td>
                  <td>
                    <template v-if="index === 0">
                      <button alt="добавить цену" @click="addExtraProjectPrice(modalData, price.site_id)"
                              class="btn btn-xs btn-outline-success"><i class="icon-fa icon-fa-plus"/></button>
                    </template>
                    <template v-else>
                      <button class="btn btn-xs btn-outline-danger" v-if="index !== 0"
                              @click="removePrice(modalData.id, price)"><i class="icon-fa icon-fa-trash-o"
                                                                           aria-hidden="true"/></button>
                    </template>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
            <div class="flex justify-content-between flex_gap_10">
              <label for="check_4">
                <input type="checkbox" v-model="showPriceRates" id="check_4">
                Редактировать коэффициенты для цен
              </label>
              <div v-if="showPriceRates" class="alert alert-info">
                <p>Спеццена: 1/2 значит 100 платформа : 200 сайт, а 2/1 значит 100 платформа : 50 сайт</p>
              </div>
            </div>
          </template>
        </div>
      </slot>
    </EmptyModal>

    <table class="table table-sm mt-0 table-hover">
      <thead>
      <tr>
        <th>Препарат</th>
        <th width="25%"></th>
        <th width="20%"></th>
        <th width="35%">Цены</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="record in records">
        <tr
          :class="{muted: +updatingDrug === record.id || (countrySelected && countrySelected !== record.income_country_id) || record.combined_type === 2}">
          <td rowspan="2" class="va-t">

            <label v-if="record.options">
              <input v-model="record.options.customSelect"
                     @change="customUpdateDrug(record, 'updateCustomSelect')"
                     type="checkbox" class="mr-1">
              <span>сохранить препарат</span>
            </label>

            <DrugGeneralInfo
              :drug="record"
              :ref="`generalInfo_${record.id}`"
              :ordered="ordered[record.id]"
              :invoices="invoices[record.id]"
              :combineInvoices="combineInvoices?.[record.id]"
              :profitCalculation="profitCalculation"
              :storeDrugData="storeDrugData[record.id]"
              :allStoreDrugsData="storeDrugData"
              :soldData="soldData[record.id]"
              :ordersStat="ordersStat[record.id]"
              :displaySettings="displaySettings ?? {}"
              :freezeInvoices="freezeInvoices[record.id]"
              :allowToOrder="true"
              :onOrderSelect="(id) => openOrderModal(id)"
            />

          </td>
          <td rowspan="2" class="va-t">

            <DrugSoldStatistics
              :drug="record"
              :fixedDates="fixedDates"
              :invoices="invoices[record.id]"
              :ordersStat="ordersStat[record.id]"
              :soldData="soldData[record.id]"
              :soldDiffData="soldDiffData[record.id]"
            />

            <div class="flex flex_gap_5 flex-wrap border-bottom mb-1">
              <div v-for="sPrice in (record?.supplier_price_details ?? [])" v-if="sPrice.supplier_price"
                   class="supplier_price_block">
                <div class="flex flex_gap_10">
                  <div class="card p-1" v-for="(kk, ii) in getUtekaRates(sPrice, record)">
                    <template v-if="ii === 0">
                      <div class="flex flex_gap_5" v-if="sPrice.supplier_price">
                        <a v-if="sPrice.supplier_price.source_url" :href="sPrice.supplier_price.source_url"
                           target="_blank">
                          <i class="icon-fa icon-fa-globe"/></a> Uteka
                        <span
                          :class="{'align-self-center': true, 'badge badge-warning': !sPrice.supplier_price.status, 'text-muted': sPrice.supplier_price.status}">{{
                            printDate(sPrice.supplier_price.scan_date, 'DD.MM.YYYY')
                          }}</span>
                        <UtekaHistoryRecords :drug-id="record.id" :detail-id="sPrice.id"/>
                      </div>
                    </template>
                    <template v-else>
                      <p>коэффициент: <strong>{{ kk.value || 1 }}</strong></p>
                    </template>
                    <template v-if="+(sPrice.supplier_price?.extra_data?.in_stores ?? 0) === 0">
                      <p>нет в аптеках</p>
                      <p>цена на <strong>{{
                          printDate(sPrice.supplier_price.extra_data.last_date, 'DD.MM.YYYY')
                        }}</strong>
                        - <span>{{
                            Math.round((sPrice.supplier_price?.extra_data?.last_price ?? 0) * (kk.value || 1))
                          }}р</span>
                      </p>
                    </template>
                    <template v-else>
                      <div class="flex flex_gap_10">
                        <div>
                          <p>мин. <strong>{{
                              Math.round((sPrice.supplier_price?.extra_data?.min_price ?? 0) * (kk.value || 1))
                            }}</strong> Ø
                            <strong>{{
                                Math.round((sPrice.supplier_price?.extra_data?.avarage_price ?? 0) * (kk.value || 1))
                              }}</strong>
                          </p>
                          <p v-if="ii===0">аптек: <strong>{{
                              sPrice.supplier_price?.extra_data?.in_stores ?? 0
                            }}</strong>
                            <span
                              v-if="sPrice.supplier_price?.extra_data?.pickup_shop">(с/в <strong>{{
                                sPrice.supplier_price.extra_data.pickup_shop
                              }}</strong>)</span>
                          </p>
                        </div>
                      </div>
                    </template>
                    <p v-if="kk.comment">{{ kk.comment }}</p>
                  </div>
                </div>
              </div>
              <div class="supplier_price_block card p-1" v-for="rd in record.drug_relations"
                   v-if="rd?.related_drug?.actual_stat">
                <p>003: {{ rd.related_drug?.title }}</p>
                <div class="flex flex_gap_10">
                  <div>
                    <LoadStoreTrendData type="price" :record="rd.related_drug.actual_stat"/>
                    <span>{{ rd.related_drug.actual_stat.price }}</span>
                  </div>
                  <div>
                    <LoadStoreTrendData type="store" :trend="+rd.related_drug.actual_stat.store_trend"
                                        :record="rd.related_drug.actual_stat"/>
                    <span>{{ rd.related_drug.actual_stat.stores }}</span>
                  </div>
                </div>
              </div>
            </div>

          </td>
          <td class="va-t">
            <template v-if="!(hideBlocks && hideBlocks.priceEdit) && masterChanges[record.id]">
              <div>
                <div class="custom-control custom-radio">
                  <input type="radio" :id="`customRadio_${record.id}_1`" v-model="masterChanges[record.id].updateType"
                         value="1" class="custom-control-input">
                  <label class="custom-control-label pointer" :for="`customRadio_${record.id}_1`">Разные цены по
                    проектам</label>
                </div>
                <div class="custom-control custom-radio">
                  <input type="radio" :id="`customRadio_${record.id}_2`" v-model="masterChanges[record.id].updateType"
                         value="2" class="custom-control-input">
                  <label class="custom-control-label pointer" :for="`customRadio_${record.id}_2`">Фиксированная
                    цена</label>
                </div>
              </div>
              <label for="">Мастер цена</label>
              <div class="input-group mb-1">
                <div class="input-group-prepend">
                  <select disabled class="custom-select">
                    <option value="1" selected>1</option>
                  </select>
                </div>
                <input v-model="masterChanges[record.id].price" type="number" class="form-control">
              </div>
              <div class="input-group"
                   v-for="(price, priceIndex) in getSortedPrices(masterChanges[record.id].extraPrices)">
                <div class="input-group-prepend">
                  <select v-model="price.qty" class="custom-select">
                    <option v-for="qty in 9" :value="(qty + 1)">{{ qty + 1 }}</option>
                  </select>
                </div>
                <input type="number" placeholder="цена" v-model="price.price" class="form-control">
                <div class="input-group-append">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" :id="`set_all_${record.id}_qty_${price.qty}`" v-model="price.setAll"
                           class="custom-control-input">
                    <label class="custom-control-label" :for="`set_all_${record.id}_qty_${price.qty}`">Все</label>
                  </div>
                  <div class="remove_extra_price_block">
                    <button @click="removeExtraPrice(record.id, priceIndex)" type="button"
                            class="btn btn-outline-danger btn-xs">x
                    </button>
                  </div>
                </div>
              </div>
              <button @click="addExtraPrice(record.id)" class="btn btn-outline-info mt-1 mb-1">Добавить цену</button>
              <button @click="updatePrices(record)" class="btn btn-outline-success mb-1 mt-1">Установить цены</button>
              <button @click="openPriceModal(record)" class="btn btn-outline-info mb-1 mt-1">Управление ценами</button>
            </template>

            <div class="mt-1">
              <label for="">Цены для справочных</label>
              <div class="input-group">
                <input class="form-control" type="number" v-model="fixedPrice[12][record.id]">
                <div class="input-group-append">
                  <button @click="updateFixedPrices(record.id)" class="btn btn-outline-info">Установить</button>
                </div>
              </div>
            </div>

            <p>Продажи по ценам <span v-if="+record.pack_set !== 1">(в зав.уп.)</span></p>
            <div class="flex">
              <div v-for="(monthNum, i) in monthsList" class="sold_price_data_block">
                {{ monthNames[monthNum] }}
                <div>
                  <p
                    v-for="(qty, price) in (soldData[record.id] && soldData[record.id][i + 1] && soldData[record.id][i + 1].prices || [])">
                    <strong>
                      <template v-if="+record.pack_set > 1">
                        (K){{ price * +record.pack_set }}
                      </template>
                      <template v-else>
                        {{ price }}
                      </template>
                    </strong>: {{ qty }}
                  </p>
                </div>
              </div>
            </div>
            <template v-if="!extraSoldData[record.id] || extraSoldData[record.id].loading">
              <LoadingButton
                title="Показать еще +3 месяца"
                :loading="extraSoldData[record.id]?.loading"
                :color="$constants.SUCCESS_COLOR"
                :onClick="() => getSoldStatistics(record.id)"
                className="btn btn-xs btn-outline-success"
              />
            </template>
            <template v-else>
              <div class="flex">
                <div v-for="(es, i) in extraSoldData[record.id].stat" class="sold_price_data_block">
                  {{ es.title }}
                  <p v-for="(qty, price) in es.prices"><strong>{{ price }}</strong>: {{ qty }}</p>
                </div>
              </div>
            </template>
          </td>
          <td class="va-t">
            <div v-if="drugsTasks[record.id]" class="mb-1">
              <template v-for="t in drugsTasks[record.id]">
                <PriceActivityChangesBlock :task="t"/>
              </template>
            </div>

            <div class="black_list_block" v-if="record.black_list && record.black_list.length">
              <i class="icon-fa icon-fa-warning"></i> <strong>Запись в черном списке</strong>
              <v-popover
                class="inline"
                placement="left"
                trigger="hover"
              >
                <span class="popover_span">i</span>
                <template slot="popover">
                  <div>
                    <div v-for="r in record.black_list">
                      <p>
                        <strong>{{
                            r.extra_data && r.extra_data.site_id && getProfectById(r.extra_data.site_id).title || 'Все проекты'
                          }}</strong>
                      </p>
                      <template v-if="r.comments && r.comments.comment">
                        <p>{{ r.comments && r.comments.comment }}</p>
                        <p class="text-right text-muted">({{ r.comments.user_name }}) {{ printDate(r.created_at) }}</p>
                      </template>
                    </div>
                  </div>
                </template>
              </v-popover>
            </div>
            <table class="table table-sm mt-0 priceData">
              <tbody>
              <template v-for="(project, ii) in getSortedProjects()">
                <tr :class="`marked_${markedPriceLine[record.id]?.[project.id] ?? 0}`">
                  <td class="va-m">
                    <template
                      v-if="drugLinks[project.id] && drugLinks[project.id][record.id] && !drugLinks[project.id][record.id].loading">
                      <template v-if="drugLinks[project.id][record.id].success">
                        <a
                          :href="`${drugLinks[project.id][record.id].link}`"
                          target="_blank"><i class="icon-fa icon-fa-globe"></i></a>
                      </template>
                      <template v-else>
                        {{ drugLinks[project.id][record.id].message || 'Err' }}
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="project.url && getActiveDrug">
                        <i
                          v-if="!(drugLinks[project.id] && drugLinks[project.id][record.id] && drugLinks[project.id] && drugLinks[project.id][record.id].loading)"
                          @click="getActiveDrug({projectId: project.id, drugId: record.id})"
                          class="icon-fa icon-fa-cloud-download pointer"/>
                        <clip-loader
                          v-if="drugLinks[project.id] && drugLinks[project.id][record.id] && drugLinks[project.id][record.id].loading"
                          :loading="true" class="inline" :color="$constants.LOADING_COLOR" size="12px"/>
                      </template>
                    </template>
                    <span><a
                      href="#"
                      @click.prevent="openInNewPage('DrugSiteEdit', {id:record.id, projectId: project.id})"
                      target="_blank"><i class="icon-fa icon-fa-edit"/></a></span>
                    {{ project.title }}
                    <template v-if="getPriceRate(record.prices, project.id)">
                      <v-popover
                        placement="left"
                        trigger="hover"
                        class="inline"
                      >
                        <span class="popover_span">%</span>
                        <template slot="popover">
                          <div>
                            <p>Установлен коэффициент: <strong>{{ projectPriceRates[project.id].rate }}</strong></p>
                            <p>Установлена фасовка: <strong>{{ projectPriceRates[project.id].packing }}</strong></p>
                            <p>Цена на платформе * коэффициент / фасовка</p>
                          </div>
                        </template>
                      </v-popover>
                    </template>
                  </td>
                  <td>
                    <div class="flex change_buttons">
                      <template v-for="(price, index) in getPrices(record.prices, project.id)">
                        <template v-if="index === 0 && !(hideBlocks && hideBlocks.priceEdit)">
                          <div class="btn-group-toggle pointer" data-toggle="buttons"
                               @click="() => { price.is_active = !price.is_active; updateDataToSave(record, 'is_active', price.site_id)}">
                            <label v-bind:class="{'btn btn-outline-primary': true, 'active': price.is_active}">
                              <input type="checkbox" v-model="price.is_active">A
                            </label>
                          </div>
                          <div class="btn-group-toggle pointer" data-toggle="buttons"
                               @click="() => { price.order_allow = !price.order_allow; updateDataToSave(record, 'order_allow', price.site_id)}">
                            <label v-bind:class="{'btn btn-outline-primary': true, 'active': price.order_allow}">
                              <input type="checkbox" v-model="price.order_allow">З
                            </label>
                          </div>
                          <div class="btn-group-toggle pointer" data-toggle="buttons"
                               @click="() => { price.redirect_type = !price.redirect_type; updateDataToSave(record, 'redirect_type', price.site_id)}">
                            <label v-bind:class="{'btn btn-outline-primary': true, 'active': price.redirect_type}">
                              <input type="checkbox" v-model="price.redirect_type">R
                            </label>
                          </div>
                        </template>
                        <template v-if="!hidePrices[price.site_id]">
                      <span v-if="index < 2" class="price_span">{{ price.qty }}: <strong>{{
                          price.price
                        }}</strong> ({{ getProfitPercent(record, price.price) }}%)</span>
                          <span v-else class="price_span">{{ price.qty }} ...</span>
                        </template>
                      </template>
                    </div>
                  </td>
                  <template v-if="priceChanges">
                    <td class="price_changes_block">
                      <div class="flex change_buttons">
                        <template v-for="(price, index) in getPrices(priceChanges, project.id)">
                          <template v-if="!hidePrices[price.project_id]">
                        <span v-if="index < 2" class="price_span">{{ price.qty }}: <strong>{{
                            price.price
                          }}</strong> ({{ getProfitPercent(record, price.price) }}%)</span>
                            <span v-else class="price_span">{{ price.qty }} ...</span>
                          </template>
                        </template>
                      </div>
                    </td>
                  </template>
                </tr>
              </template>
              </tbody>
            </table>

            <div class="flex flex_gap_5">
              <template v-for="price in getPrices(record.prices, 1)" v-if="price.qty === 1">
                <v-popover
                  placement="left"
                  trigger="hover"
                  class="inline align-self-center"
                >
                  <span class="popover_span"><i class="icon-fa icon-fa-calculator"/></span>
                  <template slot="popover">
                    <div v-html="getProfitPercent(record, price.price, true)"/>
                  </template>
                </v-popover>
              </template>
              <span @click="openActivationDelay(record)" class="badge badge-warning small_badge pointer">
                <v-icon name="clock"/>
              </span>
            </div>

            <div class="no_country_notice" v-if="countrySelected && countrySelected !== record.income_country_id">
              Не основная страна закупки
            </div>
            <div class="no_country_notice" v-if="record.combined_type === 2">
              Препарат не для продажи отдельно!
            </div>
          </td>
        </tr>
        <tr>
          <td v-if="soldData[record.id]?.options?.showStoreTrend" colspan="2">
            <StoreTrends :drug="record"/>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>

import moment from 'moment'
import EmptyModal from '@/components/modals/EmptyModal'
import api from "@/api";
import store from "@/store";
import Popover from 'vue-js-popover'
import LoadingButton from "@/components/buttons/LoadingButton";
import DrugGeneralInfo from "@/views/nomenclature/components/details/DrugGeneralInfo";
import DrugSoldStatistics from "@/views/nomenclature/components/details/DrugSoldStatistics";
import CreatedDrugOrder from "@/views/nomenclature/components/details/CreatedDrugOrder";
import OrderDrugMain from "@/views/nomenclature/components/OrderDrugMain.vue";
import SalesPricesInfo from "@/views/nomenclature/components/details/SalesPricesInfo.vue";
import PriceActivityChangesBlock from "@/views/nomenclature/components/details/PriceActivityChangesBlock.vue";
import StoreTrends from "@/components/drugs/StoreTrends.vue";
import LoadStoreTrendData from "@/views/statistics/components/LoadStoreTrendData.vue";
import UtekaHistoryRecords from "@/components/drugs/details/UtekaHistoryRecords.vue";

export default {
  props: ['records', 'updatingDrug', 'displaySettings', 'combineInvoices', 'priceChanges', 'drugsTasks', 'countrySelected', 'fixedDates', 'hideBlocks', 'drugsOrdered', 'freezeInvoices', 'drugLinks', 'getActiveDrug', 'ordersStat', 'soldData', 'storeDrugData', 'profitCalculation', 'invoices'],
  components: {
    UtekaHistoryRecords,
    LoadStoreTrendData,
    StoreTrends,
    PriceActivityChangesBlock,
    CreatedDrugOrder,
    DrugSoldStatistics,
    DrugGeneralInfo,
    EmptyModal,
    Popover,
    LoadingButton,
    OrderDrugMain,
    SalesPricesInfo,
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
    $AllCountries() {
      return this.$store.getters['platform/countries'];
    },
    $AllProjects() {
      return this.$store.getters['platform/projects']
    },
  },
  data() {
    return {
      // profitCalculation: {},
      fixedPrice: {
        7: {},
        12: {},
      },
      extraSoldData: {},
      markedPriceLine: {},
      popover: {},
      ordered: {},
      parsedPrices: null,
      newDrugToOrder: {
        id: null,
        qty: null,
        loading: false,
      },
      showPriceRates: false,
      useRates: {
        7: true,
        12: true,
        13: true,
      },
      hidePrices: {
        4: true,
        13: true
      },
      projectPriceRates: {},
      modalData: null,
      modalOrderDrugData: null,
      masterChanges: {},
      toUpdate: {},
      soldDiffData: {},
      monthsList: [],
      monthNamesRu: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
      monthNames: {},
    }
  },
  watch: {
    'records': {
      handler: function (val, oldVal) {
        console.log('update by freeze');
        // Object.keys(this.freezeInvoices).forEach((dId) => {
        //   this.storeDrugData[dId].total = (this.storeDrugData[dId]?.total ?? 0) + this.freezeInvoices[dId].total_qty;
        // });
      },
      deep: true
    },
  },
  created() {
    console.log('created');
    // this.profitCalculation = {...this.baseProfitCalculation};
    if (this.fixedDates) {
      const startDate = moment('2022-02-28')
      this.monthsList.push(startDate.month());
      this.monthsList.push(startDate.subtract(30, 'days').month());
      this.monthsList.push(startDate.subtract(60, 'days').month());
      let currentM = moment('2022-02-28');
      this.monthsList.forEach((mN) => {
        this.monthNames[mN] = currentM.format('DD.MM') + ' - ' + currentM.subtract(30, 'days').format('DD.MM')
      })
    } else {
      this.monthsList.push(moment().month());
      this.monthsList.push(moment().subtract(1, 'months').month());
      this.monthsList.push(moment().subtract(2, 'months').month());
      let currentM = moment()
      this.monthsList.forEach((mN) => {
        this.monthNames[mN] = currentM.format('DD.MM') + ' - ' + currentM.subtract(30, 'days').format('DD.MM')
      })
    }
    const masterChanges = {}
    this.records.forEach((r) => {
      r.prices.forEach((p) => {
        if (this.fixedPrice[p.site_id]) {
          if (p.qty === 1) {
            this.fixedPrice[p.site_id][r.id] = p.price;
          }
        }
      });

      let p = r.prices.find((pp) => +pp.qty === 1 && +pp.is_active === 1 && +pp.site_id === 1);
      if (!p) {
        p = r.prices.find((pp) => +pp.qty === 1)
      }
      let setPrice = p.price ?? 0;
      let updateType = 1;
      const priceEnd = p.price % 100;
      if (!priceEnd) {
        updateType = 2;
      } else if (50 <= priceEnd <= 90) {
        setPrice = Math.floor(setPrice / 100) * 100 + 90;
      }
      masterChanges[r.id] = {updateType: updateType, extraPrices: [], price: setPrice, setAll: false}
      // console.log(r.prices);
      masterChanges[r.id].extraPrices = r.prices.reduce((acc, price) => {
        if (price.qty !== 1 && !this.hidePrices[price.site_id]) {
          const check = acc.find((a) => a.qty === price.qty)
          // console.log(price, check, acc);
          if (!check) {
            let setPrice = price.price;
            const priceEnd = price.price % 100;
            // console.log(priceEnd);
            if (masterChanges[r.id].price % 100 === 0) {
              setPrice = Math.floor(setPrice / 100) * 100;
            } else if (50 <= priceEnd <= 90) {
              setPrice = Math.floor(setPrice / 100) * 100 + 90;
              // console.log('pass', setPrice);
            }
            acc.push({qty: price.qty, price: setPrice, setAll: false})
            // console.log({qty: price.qty, price: setPrice, setAll: false}, acc);
          }
        }
        return acc
      }, [])
    })
    // console.log(masterChanges);
    this.masterChanges = {...masterChanges}
    // console.log(masterChanges);
    // if (this.freezeInvoices && Object.keys(this.freezeInvoices).length) {
    // Object.keys(this.freezeInvoices).forEach((dId) => {
    // if (!this.storeDrugData[dId]) this.storeDrugData[dId] = {total: 0};
    // this.storeDrugData[dId].total += this.freezeInvoices[dId].total_qty;
    // const invoice = (this.invoices[dId] ?? []).find((i) => i.status === 0 && i.type === 1);
    // this.freezeInvoices[dId].current_cost_price = Math.round((invoice?.cost_price ?? 0) * 100) / 100 ?? 0;
    // this.freezeInvoices[dId].cost_diff = Math.round((this.freezeInvoices[dId].cost_price - this.freezeInvoices[dId].current_cost_price) * 10) / 10
    // })
    // }
    this.ordered = {...this.drugsOrdered};
    this.records.forEach((r) => {
      if (this.drugsTasks[r.id]) {
        const sitePrices = r.prices.reduce((acc, p) => {
          if (!acc[p.site_id]) acc[p.site_id] = {};
          acc[p.site_id][p.qty] = p.price;
          return acc;
        }, {});
        this.drugsTasks[r.id].forEach((t, ii) => {
          t.task_data.changes.forEach((c, i) => {
            this.drugsTasks[r.id][ii].task_data.changes[i].taskProfit = this.getProfitPercent(r, c.price);
            this.drugsTasks[r.id][ii].task_data.changes[i].actualProfit = this.getProfitPercent(r, sitePrices[c.project_id][c.qty]);
            this.drugsTasks[r.id][ii].task_data.changes[i].actualPrice = sitePrices[c.project_id][c.qty];
          });
        });
      }
    })
    this.getSoldDiffData();
  },
  methods: {
    openActivationDelay(drug) {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data: {
          drug,
          drawer: {small: true},
          type: 'ActivationDrugDelay',
        },
        // callBackAction: 'closeOrderModal'
      })
    },
    async getSoldDiffData() {
      const {data} = await api.post('/analytics/drugs/sales', {
        ids: this.records.map((d) => d.id)
      });
      if (data.success) {
        this.soldDiffData = data.records.reduce((acc, r) => {
          const lsr = Math.round(r.total_qty / data.days * 10) / 10;
          const psr = Math.round((data.presentSold[r.drug_id]?.total_qty ?? 0) / data.present_days_diff * 10) / 10
          acc[r.drug_id] = {
            ...r,
            present_sold: data.presentSold[r.drug_id]?.total_qty ?? 0,
            last_sold_rate: lsr,
            preset_sold_rate: psr,
            sold_diff: lsr - psr,
            days: data.days,
            history_date: data.history_date,
            start_date: data.start_date
          };
          return acc;
        }, {});
      }
    },
    getUtekaRates(sPrice, record) {
      const arr = [{type: 0, value: 1, comment: sPrice?.extra_data?.comment}];
      if (+sPrice.decimal_value && +sPrice.decimal_value !== 1) {
        arr.push({
          type: 1,
          value: +sPrice.decimal_value,
          // comment: sPrice?.extra_data?.comment
        });
      }
      // if (arr.length === 1) {
      //   arr[0].comment = sPrice?.extra_data?.comment;
      // }
      // console.log(arr);
      return arr;
    },
    async getSoldStatistics(drugId) {
      if (!this.extraSoldData[drugId]) {
        this.$set(this.extraSoldData, drugId, {loading: true, data: {}});
      }
      const {data} = await api.index('/drugs/soldStatistics/' + drugId);
      if (data.success) {
        // console.log(data);
        const statData = data.data.e30days.indexes.reduce((acc, days, i) => {
          if (i <= 2) return acc;
          const prices = Object.keys(data.data.e30days.values.prices[i] || {}).reduce((accPrices, price) => {
            let priceIndex = null;
            [-50, -40, -30, -20, -10, 0, 10, 20, 30, 40, 50].forEach((inc) => {
              if (priceIndex) return;
              if (accPrices[(+price + inc)]) priceIndex = (+price + inc);
            })
            if (priceIndex === null) {
              priceIndex = +price;
              accPrices[priceIndex] = 0;
            }
            accPrices[priceIndex] += +data.data.e30days.values.prices[i][price];
            return accPrices;
          }, {});
          acc.push({
            index: i,
            title: moment().subtract(days, 'days').format('DD.MM') + '-' + moment().subtract(days + 30, 'days').format('DD.MM'),
            prices
          })
          return acc;
        }, [])
        this.extraSoldData[drugId].stat = statData;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.extraSoldData[drugId].loading = false;
    },
    getGoodPriceByRate(price, rate, packing, attempts = 1) {
      if (attempts === 10) {
        toastr['warning']('нет подходящей цены по коэффициентам', 'Ошибка!');
        return 0;
      }
      let newPrice = price * rate / packing;
      if (newPrice % 1 !== 0) {
        newPrice = this.getGoodPriceByRate(price + 10, rate, packing, ++attempts);
      }
      return newPrice;
    },
    updateFixedPrices(id) {
      const projects = [7, 12, 13];
      projects.forEach((projectId) => {
        const index = this.records.findIndex((r) => r.id === id);
        if (index !== -1) {
          this.records[index].prices.forEach((p, i) => {
            if (p.site_id === projectId) {
              // console.log(p, i, this.records[index].prices[i]);
              let price = +this.fixedPrice[12][id];
              const rate = +(this.records[index].prices[i].rate ?? 1);
              const packing = +(this.records[index].prices[i].packing ?? 1);
              if (rate !== 1 || packing !== 1) {
                price = this.getGoodPriceByRate(price, rate, packing) / rate * packing;
                if (price) toastr['success']('Стоимость препарата с коэффициентами обновлена', 'Успешно!');
              }
              this.records[index].prices[i].price = price;
              if (!this.toUpdate[id]) this.toUpdate[id] = {};
              this.toUpdate[id][projectId] = [{...this.records[index].prices[i]}];
            }
          })
        }
      })
    },
    getParsedPrices() {
      return this.$refs.drugOrder && this.$refs.drugOrder.parsedPrices;
    },
    updateOrderedInvoices(drugId, ordered, drug = null) {
      const newo = {};
      newo[drugId] = ordered;
      this.ordered = {...this.ordered, ...newo}
      if (drug) {
        const index = this.records.findIndex((r) => r.id === drug.id);
        if (index !== -1) {
          this.records[index] = {...this.records[index], ...drug, details: this.records[index].details};
        }
      }
    },
    async createOrder() {
      const order = this.$refs.drugOrder.orderQty;
      const drugOrder = Object.keys(order).reduce((acc, pzn) => {
        const o = Object.keys(order[pzn]).reduce((acc, suppId) => {
          if (order[pzn][suppId].qty && order[pzn][suppId].qty > 0) {
            if (!acc[pzn]) acc[pzn] = {};
            acc[pzn][suppId] = {...order[pzn][suppId]}
          }
          return acc;
        }, {})
        if (Object.keys(o).length) {
          acc = {...acc, ...o}
        }
        return acc;
      }, {});
      if (!Object.keys(drugOrder).length) {
        toastr['warning']('Требуется ввести количество');
        return;
      }
      this.$refs.emptyOrderModal.acceptBtnLoading = true;
      const {data} = await api.post('/invoices/order/drug', {
        drug_id: this.modalOrderDrugData.drugId,
        country_id: 2, //TODO choose a country
        drugOrder
      });
      if (data.success) {
        toastr['success'](data.message || 'Сохранено', 'Успешно')
        // this.$store.dispatch('invoices/setOrderInvoices', {update: true});
        this.closeModal();
      } else {
        toastr['error'](data.message || 'Ошибка')
      }
      this.$refs.emptyOrderModal.acceptBtnLoading = false;
      // this.modalOrderDrugData
      return;
    },
    async addDrugToOrder() {
      this.newDrugToOrder.loading = true;
      const drug = this.records.find((r) => r.id === this.newDrugToOrder.id);
      let pznCode;
      if (drug) {
        const detail = drug.details.find((d) => d.alias === 'pzn');
        if (detail) {
          pznCode = detail.text_value;
        }
      }
      const {data} = await api.post('/invoices/order/drug', {
        drug_id: this.newDrugToOrder.id,
        qty: this.newDrugToOrder.qty,
        pzn: pznCode,
        country_id: this.profitCalculation.countryId,
        price: 1,
        invoice_id: null,
      })
      if (data.success) {
        toastr['success'](data.message || 'Сохранено', 'Успешно')
        this.$store.dispatch('invoices/setOrderInvoices', {update: true});

        this.popover = {};
      } else {
        toastr['error'](data.message || 'Ошибка')
      }
      this.newDrugToOrder.loading = false;
    },
    getCountryById(id) {
      const country = this.$AllCountries.find((c) => c.id === +id);
      return country || {name: 'не определено'}
    },
    getPriceRate(prices, projectId) {
      let price = prices.find((p) => p.qty === 1 && p.site_id === +projectId && p.rate && p.packing);
      if (price) {
        if (+price.rate === 1 && +price.packing === 1) price = false;
      }
      this.projectPriceRates[projectId] = price;
      return price;
    },
    getProfectById(id) {
      const project = this.$AllProjects.find((p) => p.id === +id);
      return project || {title: 'Не определен проект'}
    },
    getDetailsByGroup(record, groupAlias) {
      const details = record.details.reduce((acc, d) => {
        if (d.group_alias === groupAlias) {
          const index = d.group_parent_id || 0;
          if (!acc[index]) acc[index] = {};
          acc[index][d.alias] = d[d.type + '_value'];
          if (d.invalid) {
            acc[index].invalid = d.invalid;
          }
        }
        return acc;
      }, {})
      return Object.values(details);
    },
    removeExtraPrice(drugId, index) {
      let price = this.getSortedPrices(this.masterChanges[drugId].extraPrices)[index];
      this.masterChanges[drugId].extraPrices = this.masterChanges[drugId].extraPrices.filter((r) => !(+r.price === +price.price && +r.qty === +price.qty));
      console.log(this.masterChanges[drugId]);
    },
    getCodesByType(record, type) {
      return record.codes.filter(c => c.type_id === type)
    },
    getSortedPrices(prices) {
      console.log('sort prices');
      return _.orderBy(prices, 'qty')
    },
    async saveNewPrices() {
      if (Object.keys(this.toUpdate).length) {
        this.$refs.emptyModal.acceptBtnLoading = true
        let {data} = await api.post('/nomenclature/updatedrugs', {updateData: this.toUpdate});
        if (!data.success) {
          toastr['error'](data.message || 'Синхронизация не выполнена', 'Ошибка')
        } else {
          this.toUpdate = {};
          toastr['success'](data.message || 'Сохранено', 'Успешно')
        }
      }
      this.$refs.emptyModal.onClose(null)
    },
    openPriceModal(record) {
      record.prices.forEach((p, i) => {
        record.prices[i].project_price = p.rate && p.packing ? Math.ceil(p.price * p.rate / p.packing / 10) * 10 : null;
        record.prices[i].oldQty = p.qty;
      })
      this.modalData = {...record, acceptBtnLoading: false}
    },
    async openOrderModal(id) {
      this.modalOrderDrugData = {
        drugId: id,
        drug: {...this.records.find((r) => r.id === +id), infoPrices: []},
        suppliers: null
      }

      let pznDetails = this.modalOrderDrugData.drug.details.reduce((acc, d) => {
        if (d.group_alias === 'manufacturer') {
          const index = d.alias === 'pzn' ? d.text_value : d.group_parent_id || 0;
          if (!acc[index]) acc[index] = {};
          acc[index][d.alias] = d;
        }
        return acc;
      }, {})

      pznDetails = Object.keys(pznDetails).reduce((acc, pzn) => {
        if (pznDetails[pzn].pzn && pznDetails[pzn].pzn.group_parent_id) {
          acc[pzn] = {
            zpn: pznDetails[pzn],
            comment: pznDetails[pznDetails[pzn].pzn.group_parent_id] && pznDetails[pznDetails[pzn].pzn.group_parent_id].comment
          }
        }
        return acc;
      }, {})

      this.modalOrderDrugData.pznDetails = pznDetails;
    },
    async customUpdateDrug(record, updateAlias) {
      let {data} = await api.post('/new/drugs/update', {
        drugId: record.id,
        type: updateAlias,
        newData: record?.options?.customSelect
      });
      if (data.success) {
        toastr['success']('Сохранено', 'Успешно');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
    },
    closeModal() {
      this.modalData = null;
      this.modalOrderDrugData = null;
      this.parsedPrices = null;
      // this.$refs.emptyModal.onClose(null)
    },
    addExtraProjectPrice(record, projectId) {
      const index = this.records.findIndex(r => r.id === record.id);
      if (index === -1) return;
      this.records[index].prices.push({
        is_active: 1,
        order_allow: 1,
        drug_id: record.id,
        site_id: +projectId,
        rate: null,
        packing: null,
        qty: 2,
        price: 0
      })
      this.modalData.prices = [...this.records[index].prices];
    },
    removePrice(id, price) {
      price.to_remove = price.to_remove === undefined ? true : !price.to_remove
      const index = this.records.findIndex(r => r.id === id)
      if (index === -1) return
      this.records[index].prices = [...this.records[index].prices]
      if (!this.toUpdate[id]) this.toUpdate[id] = {};
      this.toUpdate[id][price.site_id] = this.getPrices(this.records[index].prices, price.site_id);
    },
    updatePrices(record) {
      console.log('update prices');
      if (!this.masterChanges[record.id].price) return
      if ((+this.masterChanges[record.id].price % +record.pack_set) !== 0) {
        toastr['error']('Выбранная цена не может быть использована для комплектного препарат', 'Ошибка')
        return;
      }
      let priceChange = 0
      const priceChanges = [0, 10, 20, 30]
      const masterPrices = (this.masterChanges[record.id].extraPrices || []).reduce((acc, p) => {
        acc[p.qty] = +p.price;
        return acc;
      }, {
        1: +this.masterChanges[record.id].price
      })
      const ignoreProjectsRate = [7, 12, 13];
      const projects = this.$AllProjects.reduce((acc, p) => {
        acc[p.id] = {...p};
        return acc;
      }, {})
      // console.log(record);
      // console.log(record, projects, this.masterChanges);
      record.prices.forEach((p) => {
        if (ignoreProjectsRate.includes(+p.site_id)) {
          if (p.rate && +p.rate !== 1) return;
          if (p.packing && +p.packing !== 1) return;
        }
        if (+this.masterChanges[record.id]?.updateType === 1) priceChange = priceChanges[Math.floor(Math.random() * priceChanges.length)]
        const masterPrice = masterPrices[p.qty] || 0;
        if (masterPrice) {
          if (((masterPrice - priceChange) % +record.pack_set) !== 0) {
            priceChange = 0;
          }
          p.price = (masterPrice - priceChange)
          if (!this.toUpdate[record.id]) this.toUpdate[record.id] = {};
          this.toUpdate[record.id][p.site_id] = this.getPrices(record.prices, p.site_id);
        }
      })

      const activeProjects = record.prices.filter((p) => +p.is_active && +p.qty === 1)
      this.masterChanges[record.id].extraPrices.forEach((np) => {
        activeProjects.forEach((p) => {
          if (np.qty > 1 && !projects[p.site_id].settings?.use_diff_price) return;

          if (ignoreProjectsRate.includes(+p.site_id)) {
            if (p.rate && +p.rate !== 1) return;
            if (p.packing && +p.packing !== 1) return;
          }
          let index = record.prices.findIndex((sp) => +sp.site_id === +p.site_id && +sp.qty === +np.qty)
          if (index === -1) {
            if (!np.setAll) return
            index = record.prices.length
            record.prices[index] = {
              drug_id: record.id,
              is_active: 1,
              order_allow: 1,
              site_id: p.site_id,
            }
          }
          if (+this.masterChanges[record.id]?.updateType === 1) priceChange = priceChanges[Math.floor(Math.random() * priceChanges.length)]
          if (((np.price - priceChange) % +record.pack_set) !== 0) {
            priceChange = 0;
          }
          record.prices[index].price = np.price - priceChange
          record.prices[index].qty = np.qty
          if (!this.toUpdate[record.id]) this.toUpdate[record.id] = {};
          this.toUpdate[record.id][p.site_id] = this.getPrices(record.prices, p.site_id);
          record.prices = [...record.prices]
        })
      })

      // console.log(ignoreProjectsRate);
      ignoreProjectsRate.forEach((p) => {
        if (!this.markedPriceLine[record.id]) this.markedPriceLine[record.id] = {};
        const price = record.prices.find((pp) => pp.site_id === p && pp.qty === 1);
        if (price && (price.rate > 1 || price.packing > 1)) {
          const startPrice = price.price;
          price.price = this.masterChanges[record.id].price;
          price.price = this.getCalculatedPrices(price)
          // console.log(price);
          if (!this.toUpdate[record.id][price.site_id]) this.toUpdate[record.id][price.site_id] = [];
          this.toUpdate[record.id][price.site_id].push(price);
          // console.log(startPrice, price.price);
          this.markedPriceLine[record.id][p] = +startPrice === +price.price ? 1 : 2;
        }
      })
      this.markedPriceLine = {...this.markedPriceLine};
    },
    addExtraPrice(id) {
      const maxQty = Math.max(...this.masterChanges[id].extraPrices.map((p) => +p.qty), 1);
      this.masterChanges[id].extraPrices.push({qty: (maxQty || 1) + 1, price: 0, setAll: true})
    },
    getPrices(prices, projectId) {
      let arr = prices.filter((p) => (p.site_id ?? p.project_id) === projectId);
      if (arr) {
        arr = _.orderBy(arr, 'qty')
      }
      return arr;
    },
    getSortedProjects() {
      return _.orderBy(this.$AllProjects.filter(p => p.is_active), 'order_num');
    },
    getProfitPercent(record, price, text = false) {
      // console.log(record);
      let invoices = (this.invoices[record.id] ?? []).filter((i) => +i.type === 1 && +i.status === 0)
      if (!invoices.length) {
        invoices = (this.invoices[record.id] ?? []).filter((i) => i.status === 5);
      }
      invoices = _.orderBy(invoices.map((i) => {
        return {...i, timestamp: moment(i.delivery_date).unix()}
      }), ['timestamp', 'id'], ['desc', 'desc']);

      let costPrice = +(invoices?.[0]?.cost_price ?? record.projected_price ?? 0);
      let calcText = `(${price} * (<b><u>1</u></b> - ${(this.profitCalculation.deliveryPercent ?? 0)}/<b><u>100</u></b>)`;
      calcText += ` - ${this.profitCalculation.delivery} / ${this.profitCalculation.calculatedRate} / ${costPrice} - <b><u>1</u></b>) * <b><u>100</u></b>`;
      let percent = +price * (1 - (this.profitCalculation.deliveryPercent ?? 0) / 100);
      percent -= +this.profitCalculation.delivery;
      percent /= +this.profitCalculation.calculatedRate;
      percent /= (+costPrice * +record.pack_set);
      percent = Math.round((percent - 1) * 100);
      return text ? calcText : percent;
    },
    getCalculatedPrices(price) {
      const increment = 1;
      const koeff = price.rate / price.packing;
      let newPrice = price.price * koeff;
      // console.log(newPrice);
      if (newPrice % 10 === 0 && Number.isInteger(newPrice)) return price.price;
      let calculatedPrice = Math.ceil(price.price * koeff / 10) * 10;
      newPrice = calculatedPrice / koeff;
      // console.log(newPrice);
      // if (Number.isInteger(newPrice)) return newPrice;
      price.price = +price.price + increment;
      // console.log('recursive');
      return this.getCalculatedPrices(price)
    },
    updateDataToSave(record, type, projectId, allDataRecord = {}) {
      const clonePrices = {
        12: [13],
        1: [4]
      };
      let newQty = null;
      if (allDataRecord && allDataRecord.freeze) {
        record.prices.forEach((p, i) => {
          if (+p.qty === +allDataRecord.oldQty) {
            record.prices[i].qty = +allDataRecord.qty;
            if (!this.toUpdate[record.id]) this.toUpdate[record.id] = {};
            this.toUpdate[record.id][p.site_id] = this.getPrices(record.prices, p.site_id);
          }
        })
      }
      let projectIds = [];
      if (clonePrices[projectId]) {
        projectIds = [...clonePrices[projectId]];
        const basePrices = record.prices.reduce((acc, p) => {
          if (p.site_id === +projectId) {
            acc[p.qty] = {...p}
          }
          return acc;
        }, {})
        record.prices.forEach((p, i) => {
          if (clonePrices[projectId].includes(p.site_id)) {
            if (!basePrices[p.qty]) return;
            record.prices[i].price = basePrices[p.qty].price;
            record.prices[i].rate = basePrices[p.qty].rate;
            record.prices[i].packing = basePrices[p.qty].packing;
          }
        });
      }
      projectIds.push(+projectId);

      record.prices.forEach((p, i) => {
        if (!projectIds.includes(p.site_id)) return;
        if (p.rate && p.packing && +p.qty === 1) {
          const price = this.getCalculatedPrices(p);
          record.prices[i].project_price = price * p.rate / p.packing;
          record.prices[i].price = price;
          record.prices.forEach((pp, ii) => {
            if (+pp.site_id === +p.site_id && +pp.qty !== 1) {
              record.prices[ii].rate = p.rate;
              record.prices[ii].packing = p.packing;
              const price = this.getCalculatedPrices(pp);
              record.prices[ii].project_price = price * pp.rate / pp.packing;
              record.prices[ii].price = price;
            }
          });
        }
      });
      if (this.modalData) {
        this.modalData.prices = [...record.prices];
      }
      if (!this.toUpdate[record.id]) this.toUpdate[record.id] = {};
      projectIds.forEach((p) => {
        this.toUpdate[record.id][p] = this.getPrices(record.prices, p);
      })
      if (type === 'is_active') {
        const activity = this.toUpdate[record.id][projectId].find((r) => r.qty === 1)?.is_active;
        this.toUpdate[record.id][projectId].forEach((r, i) => {
          this.toUpdate[record.id][projectId][i].is_active = activity;
        })
        if (activity) {
          this.toUpdate[record.id][projectId].forEach((r, i) => {
            this.toUpdate[record.id][projectId][i].redirect_type = false;
          })
        }
      }
      if (type === 'redirect_type') {
        const redirect = this.toUpdate[record.id][projectId].find((r) => r.qty === 1)?.[type];
        // console.log(redirect, record, projectId, this.records);
        this.toUpdate[record.id][projectId].forEach((r, i) => {
          this.toUpdate[record.id][projectId][i][type] = redirect;
        })
        if (redirect) {
          this.toUpdate[record.id][projectId].forEach((r, i) => {
            this.toUpdate[record.id][projectId][i].is_active = false;
          })
        }
      }
      // console.log(type);
    },
  }
}

</script>

<style>
.sale_data_req.red {
  color: red;
}

.sale_data_req.green {
  color: green;
}
</style>

<style scoped>
table.table tr.marked_2 {
  background-color: #ffffc6;
}

table.table tr.marked_1 {
  background-color: #c6ffdb;
}

table.table_parsed_prices td {
  padding: 3px;
  text-align: left;
}

.price_block {
  font-size: 15px;
  margin-bottom: 15px;
}

.price_block .project_title {
  width: 35px;
}

.popover_span {
  color: white;
  background-color: #5bbfde;
  padding: 2px 9px;
  cursor: pointer;
  font-weight: 700;
  border-radius: 4px;
}

.custom-control.custom-checkbox {
  margin: auto 3px;
}

.sold_price_data_block {
  padding: 3px 8px;
  margin-right: 5px;
  border: 1px solid lightgray;
}

.change_buttons .btn {
  pointer-events: none;
  padding: 1px 4px !important;
  font-size: 12px;
  margin-bottom: 2px;
  cursor: pointer;
}

.change_buttons div {
  margin-right: 3px;
}

.change_buttons label {
  vertical-align: sub;
}

.price_span {
  margin-right: 3px;
  border: 1px solid lightgray;
  padding: 3px;
}

table.table.priceData {
  border-spacing: 2px;
  border-collapse: separate;
}

table.table.priceData td {
  padding: 3px 6px;
}

.project_block {
  background-color: #afaaaa;
}

table.table td.va-t {
  vertical-align: top;
}

table.table p {
  margin-bottom: 1px;
}

.remove_extra_price_block {
  margin: auto 0;
}

.va-m {
  vertical-align: middle;
}

.black_list_block i {
  color: red;
}

.black_list_block .inline {
  display: inline;
}

.inline {
  display: inline;
}

.black_list_block p {
  margin-bottom: 0;
}

.btn-xs {
  padding: 3px 10px !important;
}

.modal_order_block .column {
  padding-right: 5px;
}

.column.min-400 {
  min-width: 400px;
}

.fs-small {
  font-size: 15px;
}

.modal_order_block .col {
  padding: 5px 5px;
}

.price_changes_block {
  background-color: #00b50026;
}

tr.muted {
  opacity: .4;
}

.small_badge {
  padding: 3px 9px;
  color: white;
  align-self: center;
  font-size: 14px;
}

.no_country_notice {
  font-size: 28px;
  font-weight: 500;
}
</style>
